import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { BerichteQuerySorterConfig } from 'fa-kt.types';
import { BerichteService } from '../service';

@Component({
  selector: 'fa-kt-berichte-sorter',
  templateUrl: './berichte-sorter.component.html',
  styleUrls: ['./berichte-sorter.component.css'],
})
export class BerichteSorterComponent {
  public BerichteSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public berichte: BerichteService,
  ) {
    this.BerichteSorterConfig = BerichteQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
